import React, { useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import Modal from '../../components/Modal'
import { Input } from '../../components/ModalInputs'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { createCompetence, updateCompetence } from '../../actions/competence'
import styles from './styles.module.css'
import Confirmation from '../../components/Confirmation/Confirmation'

export default function CompetenceModal({ closeModal, height, selectedItem }) {
  const dispatch = useDispatch()

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  const addMode = !selectedItem?.id

  const handleCreateCompetence = (values) => {
    dispatch(createCompetence(values))
    closeModal()
  }

  const handleUpdateCompetence = (values) => {
    dispatch(updateCompetence(values))
    closeModal()
  }

  const {
    values,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: addMode ? {} : selectedItem,
    enableReinitialize: true,
    onSubmit: addMode ? handleCreateCompetence : handleUpdateCompetence
  })

  return (
    <Modal open={!!selectedItem} height={height} onClose={handleClose} closeOnOverlayClick={true} closeOnEsc={true}>
      {!!values && (
        <>
          <div className={styles.modalMain}>
            <div className={styles.tabWrapper}>
              <div className={styles.inputsRow}>
                <div>
                  <Input
                    label='Название'
                    name='name'
                    value={values.name}
                    error={!addMode ? values?.name ?
                      values?.name?.length > 50 ? 'Не более 50 символов ' : ''
                      : 'Обязательное поле'
                      : ''}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
        </>
      )}
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}
